import fetchHelper from 'library/FetchHelper'
import { GraphQLClient, gql } from 'graphql-request'
import { API_ASDI_AUCTION_GRAPH_URL, API_ASDI_MARKETPLACE_GRAPH_URL } from 'config/constants'
import * as qs from 'query-string'
import { useCallback, useEffect, useState } from 'react'

export const infoClientAuction = new GraphQLClient(API_ASDI_AUCTION_GRAPH_URL, {
  headers: {},
})

export const infoClientMaket = new GraphQLClient(API_ASDI_MARKETPLACE_GRAPH_URL, {
  headers: {},
})

const QUERYAuctionSuccessfulsWithAddress = gql`
  query MyQuery($tokenId: String, $address: String) {
    auctionSuccessfuls(where: { tokenId: $tokenId, bidder: $address }) {
      bidder
      blockNumber
      blockTimestamp
      id
      tokenId
      totalPrice
      transactionHash
    }
  }
`

const QUERYAuctionSuccessfuls = gql`
  query MyQuery($tokenId: String) {
    auctionSuccessfuls(where: { tokenId: $tokenId }) {
      bidder
      blockNumber
      blockTimestamp
      id
      tokenId
      totalPrice
      transactionHash
    }
  }
`

const QUERYPlaceOrders = gql`
  query MyQuery($tokenId: String) {
    placeOrders(where: { tokenId: $tokenId }) {
      id
      blockNumber
      blockTimestamp
      price
      seller
      tokenId
      transactionHash
    }
  }
`

const QUERYListActivivyMarket = gql`
  query MyQuery($tokenId: String) {
    transfers(where: { tokenId: $tokenId }) {
      blockNumber
      blockTimestamp
      from
      id
      to
      tokenId
      transactionHash
    }
    placeOrders(where: { tokenId: $tokenId }) {
      blockTimestamp
      blockNumber
      id
      price
      seller
      tokenId
      transactionHash
    }
    fillOrders(where: { tokenId: $tokenId }) {
      blockNumber
      id
      blockTimestamp
      seller
      tokenId
      transactionHash
    }
  }
`

const QUERYListActivivyAuction = gql`
  query MyQuery($tokenId: String) {
    auctionCreateds(where: { tokenId: $tokenId }) {
      blockNumber
      blockTimestamp
      currentBidder
      duration
      id
      seller
      startAt
      startingPrice
      tokenId
      transactionHash
    }
  }
`

export const getAuctionSuccessfuls = async (tokenId: string): Promise<{ result?: any; error: boolean }> => {
  try {
    const result = await infoClientAuction.request(QUERYAuctionSuccessfuls, { tokenId })

    return {
      result,
      error: false,
    }
  } catch (error) {
    console.error('getAuctionSuccessfuls', error)
    return { error: true }
  }
}
export const useGetAuctionSuccessfuls = (tokenId: string) => {
  const [data, setData] = useState<any | undefined>([])

  const fetchData = useCallback(async () => {
    const { result } = await getAuctionSuccessfuls(tokenId)

    if (result?.auctionSuccessfuls) {
      setData(result?.auctionSuccessfuls)
    } else {
      setData(null)
    }
  }, [tokenId])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return [data, fetchData]
}

export const getAuctionSuccessfulsWithAddress = async (
  tokenId: string,
  address: string,
): Promise<{ result?: any; error: boolean }> => {
  try {
    const result = await infoClientAuction.request(QUERYAuctionSuccessfulsWithAddress, { tokenId, address })

    return {
      result,
      error: false,
    }
  } catch (error) {
    console.error('getAuctionSuccessfulsWithAddress', error)
    return { error: true }
  }
}
export const useGetAuctionSuccessfulsWithAddress = (tokenId: string, address: string) => {
  const [data, setData] = useState<any | undefined>([])

  const fetchData = useCallback(async () => {
    const { result } = await getAuctionSuccessfulsWithAddress(tokenId, address)

    if (result?.auctionSuccessfuls) {
      setData(result?.auctionSuccessfuls)
    } else {
      setData(null)
    }
  }, [address, tokenId])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return [data, fetchData]
}

export const getPlaceOrders = async (tokenId: string): Promise<{ result?: any; error: boolean }> => {
  try {
    const result = await infoClientMaket.request(QUERYPlaceOrders, { tokenId })

    return {
      result,
      error: false,
    }
  } catch (error) {
    console.error('getPlaceOrders', error)
    return { error: true }
  }
}
export const useGetPlaceOrders = (tokenId: string) => {
  const [data, setData] = useState<any | undefined>([])

  const fetchData = useCallback(async () => {
    const { result } = await getPlaceOrders(tokenId)

    if (result?.placeOrders?.[0]) {
      setData(result?.placeOrders?.[0])
    } else {
      setData(null)
    }
  }, [tokenId])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return [data, fetchData]
}

export const getListActivivy = async (tokenId: string): Promise<{ result?: any; error: boolean }> => {
  try {
    const [marketResult, auctionResult] = await Promise.all([
      infoClientMaket.request(QUERYListActivivyMarket, { tokenId }),
      infoClientAuction.request(QUERYListActivivyAuction, { tokenId }),
    ])

    const result = {
      ...marketResult,
      ...auctionResult,
    }

    return {
      result,
      error: false,
    }
  } catch (error) {
    console.error('getListActivivy', error)
    return { error: true }
  }
}
export const useGetListActivivy = (tokenId: string) => {
  const [data, setData] = useState<any | undefined>([])

  const fetchData = useCallback(async () => {
    const { result } = await getListActivivy(tokenId)

    if (result) {
      setData(result)
    } else {
      setData(null)
    }
  }, [tokenId])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return [data, fetchData]
}
